import { openDB } from "idb";

const DRAFT_MODULES = ['autosave_collection', 'autosave_digital', 'autosave_conservation'];

export const initializeDB = async () => {
    const db = await openDB('autosave-database', 2, {
        upgrade(db, oldVersion, newVersion, transaction) {
            DRAFT_MODULES.forEach((module) => {
                if (!db.objectStoreNames.contains('autosave')) {
                    db.createObjectStore('autosave'); // No keyPath — manual keys like "collection"
                  }
            });

        },
    });
    return db;
};

export const autoSaveToIndexedDB = async (key, data) => {
    const db = await initializeDB();
    await db.put('autosave', data, key); // key = 'collection' | 'digital' | 'conservation'
  };

  export const getAutoSavedFromIndexedDB = async (key) => {
    const db = await initializeDB();
    return await db.get('autosave', key);
  };

  export const clearAutoSavedFromIndexedDB = async (key) => {
    const db = await initializeDB();
    await db.delete('autosave', key);
  };
